module.exports = __webpack_public_path__ + "img/Glow_Wild.9ae55748.jpg";